<template>
  <div class="col-auto col-width-wide  border-right">
    <div class="w-100 h-25 text-center">
      <strong>Effectiveness Evaluation</strong>
    </div>
    <div v-if="engagement.evaluationChart" class="d-flex h-75">
      <div class="overview-chart-fixed-width align-self-center">
        <doughnutChart
          :chart-data="engagement.evaluationChart"
          :options="engagement.chartOptions"
          :textMiddle="engagement.evaluation.evaluationScaleAverage"
        ></doughnutChart>
      </div>

      <div v-if="engagement.evaluation.evaluationSubscale" class="overview-info-fixed-width mr-3 pl-3 align-self-center">
        <div class="row flex-nowrap justify-content-between">
          <div class="col-auto mr-auto">Communication:</div>
          <div class="col-auto text-right">{{engagement.evaluation.evaluationSubscale.communicationPercentage}}%</div>
        </div>
        <div class="row flex-nowrap justify-content-between">
          <div class="col-auto mr-auto">Relationships:</div>
          <div class="col-auto text-right">{{engagement.evaluation.evaluationSubscale.relationshipPercentage}}%</div>
        </div>
        <div class="row flex-nowrap justify-content-between">
          <div class="col-auto mr-auto">Planning:</div>
          <div class="col-auto text-right">{{engagement.evaluation.evaluationSubscale.planningPercentage}}%</div>
        </div>
        <div class="row flex-nowrap justify-content-between">
          <div class="col-auto mr-auto">Results:</div>
          <div class="col-auto text-right">{{engagement.evaluation.evaluationSubscale.resultsPercentage}}%</div>
        </div>
      </div>

      <div v-if="engagement.evaluation.evaluationSubscale" class="overview-info-fixed-width pl-3 align-self-center">
        <div class="row flex-nowrap justify-content-between">
          <div class="col-auto mr-auto">Resilience:</div>
          <div class="col-auto text-right">{{engagement.evaluation.evaluationSubscale.resiliencePercentage}}%</div>
        </div>
        <div class="row flex-nowrap justify-content-between">
          <div class="col-auto mr-auto">Supporting:</div>
          <div class="col-auto text-right">{{engagement.evaluation.evaluationSubscale.supportingPercentage}}%</div>
        </div>
        <div class="row flex-nowrap justify-content-between">
          <div class="col-auto mr-auto">Progression:</div>
          <div class="col-auto text-right">{{engagement.evaluation.evaluationSubscale.progressionPercentage}}%</div>
        </div>
      </div>
    </div>

    <div v-else-if="engagement.evaluation" class="d-flex h-75">
      <div class="m-auto">
        <p>Evaluation is in progress</p>
      </div>
    </div>

    <div v-else class="d-flex h-75">
      <div class="m-auto">
        <b-button v-b-modal="'modal-multi-' + engagement.employeeUID"
          >Start Evaluation</b-button
        >
        <b-modal
          :id="'modal-multi-' + engagement.employeeUID"
          ref="yepp"
          size="lg"
          title="Assign Evaluator"
          @ok="triggerCheck"
          no-stacking
          centered
        >
          <p>
            As supervisor/manager you will automatically be assigned to be one
            of the evaluators for {{ engagement.employeeName }}.
          </p>
          <p>
            {{ engagement.employeeName }} will also evaluate himself/herself to
            critically look at their own performance. Lastly, choose one other
            co-employee of {{ engagement.employeeName }} to evaluate him/her.
            This creates an unbiased evaluation.
          </p>
          <select
            name="assignedTo"
            id="assignedTo"
            class="form-control"
            @change="setEvaluator($event)"
          >
            <option disabled selected value="false">
              Assign a person to this evaluation
            </option>
            <option
              v-for="user in filteredUsers"
              :key="user.index"
              :value="user.uid"
            >
              {{ user.displayName }}
            </option>
          </select>
          {{error.msg}}
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import doughnutChart from "@/components/engagement/charts/percentageDoughnutChart.js";
import { Doughnut, mixins } from "vue-chartjs";

export default {
  extends: Doughnut,
  mixins: [mixins.reactiveProp],
  props: ["engagement", "chartData"],
  components: {
    doughnutChart,
  },
  computed: {
    ...mapGetters("users", ["getClaims", "getMe"]),
  },
  data() {
    return {
      error: {
        msg: null
      },
      allUsers: [],
      valueFilled: false,
      filteredUsers: [],
      evaluation: {
        evaluatee: {
          uid: null,
          displayName: null
        },
        assignedEvaluators: [],
        answers: [],
        companyId: null,
      },
      me: null,
    };
  },
  mounted() {},
  methods: {
    setEvaluator(event) {
      this.error.msg = null,
      this.evaluation.assignedEvaluators.splice(0);
      this.evaluation.assignedEvaluators.push(event.target.value);
      this.valueFilled = true;
    },

    triggerCheck(bvModalEvent) {
      if (this.valueFilled === true) {
        this.evaluation.assignedEvaluators.push(this.me);
        this.evaluation.assignedEvaluators.push(this.engagement.employeeUID);
        this.valueFilled = false 
        this.submitEvaluation()
      }else{
      bvModalEvent.preventDefault()
      this.error.msg = "You must choose an evaluator before you can press ok"
      }
      
    },
    async submitEvaluation(){
      this.evaluation.evaluatee.uid = this.engagement.employeeUID
      this.evaluation.evaluatee.displayName = this.engagement.employeeName
      this.evaluation.companyId = this.getClaims.companyId
      await this.$store.dispatch("evaluation/set", this.evaluation);
      await this.swalToastSuccess(this.$t("ui.saved"));
    }

  },
  async created() {
    this.me = this.getMe.uid;

    this.$store.commit("setLoading", true);
    await this.$FUNCTIONS
      .Users("getAllUsers")
      .then((res) => {
        this.allUsers = res.data;
        this.$store.commit("setLoading", false);
      })
      .catch((e) => {
        console.log(1, e);
        this.$store.commit("setLoading", false);
      });

    this.filteredUsers = this.allUsers.map((user) => {
      if (user.uid === this.engagement.employeeUID || user.uid === this.me) {
        return;
      } else {
        return user;
      }
    });

    this.filteredUsers = this.filteredUsers.filter((user) => {
      return user !== undefined;
    });
  },
};
</script>

<style scoped lang="scss">
@import "./src/assets/scss/components/engagement/_EmployeeOverviewBar.scss";
</style>